<template>
  <div class="wrapper">
    <div
      class="sf-level sf-uppercase sf-c-text-light"
      :class="progressTextClass"
    >
      <div class="sf-level-item progress-label">
        {{ I18n.t('reconciliation_proposal.pulse.progress') }}
      </div>
      <div class="sf-level-item sf-progress__value-wrapper">
        <span v-if="error">N/A</span>
        <span v-else-if="!loading">{{ workflowProgress }}%</span>
      </div>
    </div>
    <div class="sf-level">
      <div
        class="sf-progress sf-progress-tiny sf-bg-snow sf-full-width"
        :class="progressContainerClass"
      >
        <div
          class="sf-progress-complete"
          :class="progressBarClass"
          :style="progressStyle"
        ></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { usePulseWorkflowProgress } from '@app/application/workflow-overview-navigation/store/pulse-workflow-progress'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'PulseWorkflowProgress',
})

const I18n = window.I18n
const pulseWorkflowProgressStore = usePulseWorkflowProgress()
const { workflowProgress, error } = storeToRefs(pulseWorkflowProgressStore)

const loading = computed(() => workflowProgress.value === null)

const progressStyle = computed(() => ({
  width: `${workflowProgress.value}%`,
}))

const progressTextClass = computed(() => (error.value ? 'sf-c-danger' : ''))
const progressBarClass = computed(() => {
  if (loading.value) {
    return 'sf-bg-snow sf-progress__pending'
  } else {
    return 'sf-progress-complete sf-bg-primary'
  }
})
const progressContainerClass = computed(() =>
  loading.value ? 'sf-progress-animate' : ''
)
</script>

<style scoped lang="scss">
.sf-progress {
  margin-top: 4px;

  &__pending {
    width: 100%;
  }

  &__value-wrapper {
    min-width: 32px;
    text-align: right;
  }
}

.wrapper {
  min-width: 100px;

  .progress-label {
    margin-right: 8px !important;
  }
}
</style>
